import type { StylePackStates } from '@/themes/stylePack.types';

/**
 * WEB-1060 — цвет текста опции single_choice/multiple_choice, СОГЛАСОВАННЫЙ
 * с её собственной подложкой, а не с фоном страницы.
 *
 * Контекст: `--option-selected-bg` (themes/stylePackToStyle.ts) переключает
 * подложку ВЫБРАННОЙ опции по режиму пака:
 *   • 'filled'            → var(--color-primary)
 *   • 'brand-border-tint' → var(--color-bg-surface)
 *   • 'ring' / 'check-badge' → подложка не меняется (transparent) — тот же
 *     CSS-фолбэк, что у полного отсутствия пака в PublicBlockRenderer.tsx:
 *     `var(--option-selected-bg, var(--color-bg-surface, transparent))`.
 *     Важно: у ОТСУТСТВИЯ ПАКА подложка ведёт себя как 'brand-border-tint'
 *     (падает в --color-bg-surface), а не как 'ring'/'check-badge' —
 *     `undefined` здесь резолвится ТУДА ЖЕ, куда 'brand-border-tint'.
 *
 * Текст раньше не переключался НИКОГДА — опция всегда красилась
 * `primaryColor`, посчитанным против ФОНА СТРАНИЦЫ гардом WEB-1009
 * (funnelContrastGuard.ts). На фото-фоне с вуалью текст страницы светлый; на
 * подложке 'filled'/'brand-border-tint' (обычно светлой/брендовой, НЕ равной
 * фону страницы) светлый текст становится нечитаемым — «белым по белому».
 *
 * Пара «подложка выбора ↔ текст выбора» — из ОДНОГО источника: те же токены,
 * что уже красят текст на этих же подложках в других местах воронки —
 * `--color-on-primary` (WEB-872, текст на --color-primary — кнопки Next/Pay)
 * и `--color-text-on-surface` (WEB-966, текст на --color-bg-surface —
 * карточки/чипы/инпуты). Собственного замера контраста функция не делает.
 */
export function resolveSelectedOptionColor(
  selectedMode: StylePackStates['selected'] | undefined,
  primaryColor: string,
  isSelected = true,
): string {
  if (!isSelected) return primaryColor;

  // 'ring' / 'check-badge': подложка остаётся прозрачной — текст остаётся
  // тем же, что и у невыбранного варианта (регресс-гард WEB-1060).
  if (selectedMode === 'ring' || selectedMode === 'check-badge') {
    return primaryColor;
  }

  // Решение владельца №2: 'gradient' — та же заливка брендом, что 'filled',
  // только градиентом (--gradient-selected), текст — on-primary.
  if (selectedMode === 'filled' || selectedMode === 'gradient') {
    return 'var(--color-on-primary, #fff)';
  }

  // 'brand-border-tint' И отсутствие пака (тот же CSS-фолбэк подложки на
  // --color-bg-surface).
  return 'var(--color-text-on-surface, var(--color-text-primary, inherit))';
}
